module.exports = __webpack_public_path__ + "img/zeno-6.7b1a7f6d.jpg";